import { DateField } from "@mui/x-date-pickers";
import { styled } from "@mui/material";

export const StyledDateField = styled(DateField)`
  width: 12.857rem;
`;
